import { Button } from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"
import { addTaskButton, addSectionButton } from "./styled-components/column"
import type { ReactNode } from "react"

interface AddButtonProps {
  type: "section" | "task"
  onClick: () => void
  children: ReactNode
}

export function AddButton({ onClick, children, type }: AddButtonProps) {
  return (
    <Button
      type="text"
      onClick={onClick}
      style={type === "task" ? addTaskButton : addSectionButton}
    >
      <PlusCircleOutlined style={{ transform: "translateY(1px)" }} />
      <div style={{ fontWeight: "600" }}>{children}</div>
    </Button>
  )
}
